import Card from "./Card";
import React from "react";
import ResultsCount from "./ResultsCount";
import getSearchResultsSelector from "../../../../state/selectors/SearchSelectors/getSearchResultsSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

const SearchResults: React.FC = () => {
    const results = useSelector((state: Store) => getSearchResultsSelector(state));
    return (
        <SearchContainer>
            <ResultsCount />
            {results.map((item: any) => {
                return (
                    <Card
                        key={item.ID}
                        id={item.ID}
                        title={item.post_title}
                        type={item.post_type}
                        name={item.post_name}
                        description={item.fields.what_it_does}
                        categories={item.categories.map((category: any) => category.name).join(", ")}
                    />
                );
            })}
        </SearchContainer>
    );
};

export default SearchResults;

const SearchContainer = styled.div`
    /* position: absolute; */
    left: 0;
    right: 0;
    bottom: 0;
    top: 4.5rem;
    z-index: 1;
    padding: 1rem;
    transition: opacity 0.3s ease;
`;
